import ContrastIcon from '@mui/icons-material/Contrast';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import { useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { setAppearance, useAppearance, type Appearance } from '../appearance';

const options: { value: Appearance; labelKey: string; icon: ReactNode }[] = [
  { value: 'system', labelKey: 'appearance.system', icon: <ContrastIcon fontSize="small" /> },
  { value: 'light', labelKey: 'appearance.light', icon: <LightModeIcon fontSize="small" /> },
  { value: 'dark', labelKey: 'appearance.dark', icon: <DarkModeIcon fontSize="small" /> },
];

/// Light or dark, or whatever the desktop is doing. Beside the language rather than in the
/// settings: both are what one person wants on one screen, neither is the server's business.
export default function AppearanceMenu() {
  const { t } = useTranslation();
  const { appearance, mode } = useAppearance();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  return (
    <>
      <Tooltip title={t('appearance.title')}>
        <IconButton onClick={(event) => setAnchor(event.currentTarget)} aria-label={t('appearance.title')}>
          {/* What it is now, not what pressing it would do - the menu says that. */}
          {mode === 'dark' ? <DarkModeIcon /> : <LightModeIcon />}
        </IconButton>
      </Tooltip>

      <Menu anchorEl={anchor} open={anchor !== null} onClose={() => setAnchor(null)}>
        {options.map((option) => (
          <MenuItem
            key={option.value}
            selected={appearance === option.value}
            onClick={() => {
              setAppearance(option.value);
              setAnchor(null);
            }}
          >
            <ListItemIcon>{option.icon}</ListItemIcon>
            {t(option.labelKey)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
